import {Grid} from "@mui/material";
import {useState} from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import TabPanel from "../ui/TabPanel";
import { useEffect } from "react"
import ProgramFeeCard from "../cards/ProgramFee";
import ProgramFeePayments from "./ProgramFeePayments";
import LoadingContent from "../common/LoadingContent"
import { useParams } from "react-router-dom"
import { getProgramStats } from "../../api"
import { useSnackbar } from "notistack"

const ProgramFeeDetails = () => {
  const [program, setProgram] = useState({});
  const [tabIndex, setTabIndex] = useState(0);
  const changeTab = (_, newValue) => setTabIndex(newValue);
  const [loading, setLoading] = useState(false)
  const { programId } = useParams();
  const { enqueueSnackbar } = useSnackbar()

  const fetchProgram = () => {
    setLoading(true)
    getProgramStats({programId: programId})
      .then((res) => {
        setProgram({...res.data, totalFee: res.data?.summary?.totalFee, totalCollected: res.data?.summary?.totalCollected, totalBalance: res.data?.summary?.totalBalance})
      })
      .catch((err) => enqueueSnackbar(err.data, { variant: "error" }))
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    fetchProgram()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Grid container spacing={2}>
      <Grid item xs={4}>
        <LoadingContent loading={loading}>
        <ProgramFeeCard data={program} noView />
        </LoadingContent>
      </Grid>
      <Grid item xs={8}>
        <Box sx={{borderBottom: 1, borderColor: "divider"}}>
          <Tabs value={tabIndex} onChange={changeTab}>
            <Tab label="Payments" />
          </Tabs>
        </Box>
        <TabPanel value={tabIndex} index={0}>
          <ProgramFeePayments setProgram={setProgram} />
        </TabPanel>
      </Grid>
    </Grid>
  );
};

export default ProgramFeeDetails;
